import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import React from "react";
export const CheckBox = React.forwardRef((props, ref) => {
    const { label, className, style, labelClassName, labelStyle, inputClassName, inputStyle, onChange, children, ...rest } = props;
    const disabled = props.disabled;
    const content = children || label;
    return _jsxs("label", { className: classNames("x-check", className, { disabled: disabled }), style: style, children: [_jsx("label", { className: inputClassName, style: inputStyle, children: _jsx("input", { ref: ref, type: "checkbox", ...rest, onChange: e => onChange?.(e.target.checked) }) }), content ? _jsx("span", { className: labelClassName, style: labelStyle, children: content }) : null] });
});
